module.exports = __webpack_public_path__ + "static/media/x-circle.0843266b.svg";